import React from 'react';

export default function IndustryIcon() {
  return (
    <svg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M10.6663 13.332V2.66536C10.6663 2.31174 10.5259 1.9726 10.2758 1.72256C10.0258 1.47251 9.68663 1.33203 9.33301 1.33203H6.66634C6.31272 1.33203 5.97358 1.47251 5.72353 1.72256C5.47348 1.9726 5.33301 2.31174 5.33301 2.66536V13.332'
        stroke='#195EFF'
        stroke-width='1.33333'
        stroke-linecap='round'
        stroke-linejoin='round'
      />
      <path
        d='M13.333 4H2.66634C1.92996 4 1.33301 4.59695 1.33301 5.33333V12C1.33301 12.7364 1.92996 13.3333 2.66634 13.3333H13.333C14.0694 13.3333 14.6663 12.7364 14.6663 12V5.33333C14.6663 4.59695 14.0694 4 13.333 4Z'
        stroke='#195EFF'
        stroke-width='1.33333'
        stroke-linecap='round'
        stroke-linejoin='round'
      />
    </svg>
  );
}
